import { render, staticRenderFns } from "./DialogContentWhatsIncludedValuablesInHome.vue?vue&type=template&id=aceeb604&scoped=true&"
import script from "./DialogContentWhatsIncludedValuablesInHome.vue?vue&type=script&lang=js&"
export * from "./DialogContentWhatsIncludedValuablesInHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aceeb604",
  null
  
)

export default component.exports